var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMusic(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 77,
    height: 77,
    viewBox: "0 0 77 77",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_945",
    "data-name": "Group 945",
    transform: "translate(-1354 -4941)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1167",
    "data-name": "Rectangle 1167",
    width: 77,
    height: 77,
    transform: "translate(1354 4941)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Music",
    d: "M140,104.071a11.748,11.748,0,0,0,23.5,0V75.713l28.2-2.013V85.274h-7.049a11.748,11.748,0,1,0,11.748,11.748v-34.9a7.05,7.05,0,0,0-7.552-7.033l-23.5,1.68h0A7.073,7.073,0,0,0,158.8,63.8V92.322h-7.049A11.763,11.763,0,0,0,140,104.07Zm51.692-7.049a7.049,7.049,0,1,1-7.049-7.049h7.049ZM165.68,61.461l23.5-1.68a2.35,2.35,0,0,1,2.516,2.35v6.859L163.5,71V63.8a2.35,2.35,0,0,1,2.183-2.343ZM151.748,97.022H158.8v7.049a7.049,7.049,0,1,1-7.049-7.049Z",
    transform: "translate(1224 4893.926)",
    fill: "#016dd9"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMusic);
export default __webpack_public_path__ + "static/media/Music.3be8e01b0e3173c3ce833fc0a76523ad.svg";
export { ForwardRef as ReactComponent };